'use client';
import React, { useState } from 'react';
import GardeniaContainer from '@components-launch/Gardenia-Bay/GardeniaContainer';
import cn from './style.module.scss';

interface TabDataProps {
  tabs: Array<{
    heading: string;
    description: string;
    listElement: Array<string>;
    images: Array<{ url: string }>;
  }>;
}

export default function TabData({ tabs }: TabDataProps) {
  const [activeTab, setActiveTab] = useState(0);
  if (!tabs || tabs.length === 0) {
    return null; // or some fallback UI
  }
  return (
    <GardeniaContainer>
      <div className={cn.launchGardeniaSpec}>
        <div className={cn.launchGardeniaSpec__header}>
          <h2>
            <span>{tabs[activeTab].heading}</span>
          </h2>
          <p>{tabs[activeTab].description}</p>
        </div>
        <div className={cn.launchGardeniaSpec__category}>
          <div className={cn.launchGardeniaList}>
            <ul className={cn.launchGardeniaWrapper}>
              {tabs[activeTab].listElement.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
          <div className={cn.launchGardeniaTheme}>
            <div className={cn.launchGardeniaImage}>
              {tabs[activeTab].images.map((image, index) => (
                <img key={index} src={image.url} alt={`Image ${index + 1}`} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </GardeniaContainer>
  );
}
